/** 會員尊享 - 分類 */
export enum ExclusiveOfferLegacyType {
  /** 餐飲 */
  RESTAURANT = '0',
  /** 購物 */
  SHOPPING = '1',
  /** 住宿 */
  ACCOMMODATION = '2',
  /** 交通 */
  TRANSPORTATION = '3',
  /** 網路 */
  NETWORK = '4',
  /** 娛樂 & 體驗 */
  ENTERTAINMENT = '5',
  /** 其他 */
  OTHERS = '6'
}
